/**
 * The 38px collapsed rail — README "4. Context + AI pane (pane C)":
 * "collapsed it becomes a 38px rail with vertical CONTEXT and AI labels,
 * '«' to expand, and a blue dot on AI when it has something unread."
 */
import { activateOnKey } from '../rail/format'

export interface CollapsedRailProps {
  onExpand: () => void
  onExpandContextTab: () => void
  onExpandAiTab: () => void
  aiUnread: boolean
}

export function CollapsedRail({ onExpand, onExpandContextTab, onExpandAiTab, aiUnread }: CollapsedRailProps) {
  return (
    <div
      data-testid="context-rail-collapsed"
      className="flex h-full w-[38px] flex-none flex-col items-center gap-4 bg-sidebar py-[10px]"
    >
      <div
        role="button"
        tabIndex={0}
        data-testid="context-expand-btn"
        onClick={onExpand}
        onKeyDown={(e) => activateOnKey(e, onExpand)}
        className="flex h-6 w-6 cursor-pointer items-center justify-center rounded-[7px] border border-subtle text-[12px] text-mid"
      >
        «
      </div>
      <div
        role="button"
        tabIndex={0}
        data-testid="context-rail-context-tab"
        onClick={onExpandContextTab}
        onKeyDown={(e) => activateOnKey(e, onExpandContextTab)}
        className="cursor-pointer text-[11px] font-semibold tracking-[.08em] text-mid"
        style={{ writingMode: 'vertical-rl' }}
      >
        CONTEXT
      </div>
      <div
        role="button"
        tabIndex={0}
        data-testid="context-rail-ai-tab"
        onClick={onExpandAiTab}
        onKeyDown={(e) => activateOnKey(e, onExpandAiTab)}
        className="flex cursor-pointer flex-col items-center gap-1.5"
      >
        <div className="text-[11px] font-semibold tracking-[.08em] text-mid" style={{ writingMode: 'vertical-rl' }}>
          AI
        </div>
        {aiUnread && <div data-testid="ai-unread-dot" className="h-1.5 w-1.5 rounded-full bg-cc-blue" />}
      </div>
    </div>
  )
}
